import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import {Typography, Paper, Box, Card, CardContent} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function SumStep(A, B, C, iA, iB, iC) {
  const sum = iA < A.length && iB < B.length && iC >= 0 ? A[iA] + B[iB] + C[iC] : null;

  if (sum === 0) {
    return { iA, iB, iC, found: true, finished: true };
  } else if (sum < 0) {
    if (iB + 1 < B.length) {
      return { iA, iB: iB + 1, iC, found: false, finished: false };
    } else {
      // Check if incrementing iA goes beyond bounds
      if (iA + 1 < A.length) {
        return { iA: iA + 1, iB: 0, iC: C.length - 1, found: false, finished: false };
      } else {
        return { iA, iB, iC, found: false, finished: true };
      }
    }
  } else if (sum > 0) {
    if (iC - 1 >= 0) {
      return { iA, iB, iC: iC - 1, found: false, finished: false };
    } else {
      // Check if incrementing iA goes beyond bounds
      if (iA + 1 < A.length) {
        return { iA: iA + 1, iB: 0, iC: C.length - 1, found: false, finished: false };
      } else {
        return { iA, iB, iC, found: false, finished: true };
      }
    }
  }

  // If sum is null, meaning we've exhausted all possibilities
  return { iA, iB, iC, found: false, finished: true };
}




function SumVisualization({ A, B, C, iA, iB, iC, finished }) {

function renderList(list, pointerIndex, color, label) {
  return (
    <Grid item xs={4}>
      <Paper style={{ padding: '10px', backgroundColor: color }}>
        {list.map((item, index) => (
          <Box key={index} style={{ display: 'flex', alignItems: 'center', margin: '5px 0' }}>
            <Typography>{item}</Typography>

            {index === pointerIndex && (
              <Box style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                <ArrowBackIcon />
                <Typography>{label}</Typography>

              </Box>
            )}
          </Box>
        ))}
      </Paper>
    </Grid>
  );
}
const comparisonValue = A[iA] + (B[iB] + C[iC]);

  const found = comparisonValue === 0;

  return (
    <Box>
      <Grid container spacing={2}>
        {renderList(A, iA, '#FFCDD2', 'a')}
        {renderList(B, iB, '#C8E6C9', 'b')}
        {renderList(C, iC, '#BBDEFB', 'c')}
      </Grid>
      <Card variant="outlined" style={{ margin: '20px', padding: '10px' }}>

          <Typography variant="h6">a+b+c vs 0:</Typography>
          <Typography>
            {A[iA]} + {B[iB]} + {C[iC]} {comparisonValue === 0 ? "=" : comparisonValue < 0 ? "<" : ">"} 0
          </Typography>
          {/* Conditional rendering based on finished and found */}
          {finished && (
            <Typography variant="h6" style={{ color: found ? 'green' : 'red' }}>
              {found ? "Solution Found" : "No Solution Found"}
            </Typography>
          )}
      </Card>
    </Box>
  );
}

function SumState({ A, B, C, stepInterval = 1000 }) {
  const [iA, setIA] = useState(0);
  const [iB, setIB] = useState(0);
  const [iC, setIC] = useState(C.length - 1);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      if (!finished) {
        const { iA: newIA, iB: newIB, iC: newIC, found, finished: isFinished } = SumStep(A, B, C, iA, iB, iC);

        setIA(newIA);
        setIB(newIB);
        setIC(newIC);
        setFinished(isFinished);

        if (found) {
          console.log('Solution found:', A[newIA], B[newIB], C[newIC]);
          clearInterval(timer);
        } else if (isFinished) {
          console.log('No solution found');
          clearInterval(timer);
        }
      }
    }, stepInterval);

    return () => clearInterval(timer);
  }, [iA, iB, iC, finished, A, B, C, stepInterval]);

  return (
    <Card style={{ backgroundColor: 'black', color: 'white' }}>
      <Typography variant={"h5"} style={{ color: 'white' }}>3-SUM Visualization</Typography>
      <CardContent>
        <SumVisualization A={A} B={B} C={C} iA={iA} iB={iB} iC={iC} finished={finished} />
      </CardContent>
    </Card>
  );
}

export default SumState;